import { Environment } from '~/core';

export function useDerbySoftPixel() {
  const derbySoftPixelCall = (
    eventType: string,
    payload: Record<string, string>,
  ) => {
    const { appEnv, derbySoftPixelUrl } = useRuntimeConfig().public;

    if (process.server || appEnv !== Environment.Pro.toString()) {
      return;
    }

    const dbParams: Record<string, string> = {
      pixel_id: '10180',
      account_id: 'manageddigital',
      event_type: eventType,
      ...payload,
    };

    const params = new URLSearchParams(dbParams).toString();

    return fetch(`${derbySoftPixelUrl}?${params}`);
  };

  return { derbySoftPixelCall };
}
